import React, { lazy, Suspense } from "react"
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"

// Lazy-load pages for code splitting (replaces Gatsby's per-page bundles)
const IndexPage = lazy(() => import("./pages/index"))
const HeroCarousel = lazy(() => import("./pages/hero-carousel"))
const EndlessScroll = lazy(() => import("./pages/endless-scroll"))
const EndlessScrollV2 = lazy(() => import("./pages/endless-scroll-v2"))
const EndlessScrollSandals = lazy(() => import("./pages/endless-scroll-sandals"))
const EndlessScrollArmedAngels = lazy(() => import("./pages/endless-scroll-armedangels"))
const EndlessScrollSandalsStl = lazy(() => import("./pages/endless-scroll-sandals-stl"))
const GridInsights = lazy(() => import("./pages/grid-insights"))
const Products = lazy(() => import("./pages/products"))
const TrackCarousel = lazy(() => import("./pages/track-carousel"))
const TrackCarouselPca = lazy(() => import("./pages/track-carousel-pca"))
const CinematicProduct = lazy(() => import("./pages/cinematic-product"))
const ThreeDDemo = lazy(() => import("./pages/3d-demo"))
const Sandals3DDiagram = lazy(() => import("./pages/sandals-3d-diagram"))
const SandalsFusionTest = lazy(() => import("./pages/sandals-fusion-test"))
const SandalsStlCarousel = lazy(() => import("./pages/sandals-stl-carousel"))
const SandalsBakedLibrary = lazy(() => import("./pages/sandals-baked-library"))
const SandalsLiveExplorer = lazy(() => import("./pages/sandals-live-explorer"))
const SandalsMorphLab = lazy(() => import("./pages/sandals-morph-lab"))
const SandalsMorphLabMobile = lazy(() => import("./pages/sandals-morph-lab-mobile"))
const Engagement = lazy(() => import("./pages/engagement"))
const Start = lazy(() => import("./pages/start"))
const NotFound = lazy(() => import("./pages/404"))

// Strip trailing slash so basename works in both dev ("/") and preview ("/sales-engine/")
const ROUTER_BASE = import.meta.env.BASE_URL.replace(/\/$/, "")

function App() {
  return (
    <BrowserRouter basename={ROUTER_BASE}>
      <Suspense
        fallback={
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
              fontFamily: "'Circular Std', sans-serif",
              color: "#666",
            }}
          >
            Loading...
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<IndexPage />} />
          <Route path="/hero-carousel" element={<HeroCarousel />} />
          {/* Legacy redirect — preserves any existing bookmarks to the old path */}
          <Route path="/sales-engine" element={<Navigate to="/hero-carousel" replace />} />
          <Route path="/endless-scroll" element={<EndlessScroll />} />
          <Route path="/endless-scroll-v2" element={<EndlessScrollV2 />} />
          <Route path="/endless-scroll-sandals" element={<EndlessScrollSandals />} />
          <Route path="/endless-scroll-armedangels" element={<EndlessScrollArmedAngels />} />
          <Route path="/endless-scroll-sandals-stl" element={<EndlessScrollSandalsStl />} />
          <Route path="/grid-insights" element={<GridInsights />} />
          <Route path="/products" element={<Products />} />
          <Route path="/track-carousel" element={<TrackCarousel />} />
          <Route path="/track-carousel-pca" element={<TrackCarouselPca />} />
          <Route path="/cinematic-product" element={<CinematicProduct />} />
          <Route path="/3d-demo" element={<ThreeDDemo />} />
          <Route path="/sandals-3d-diagram" element={<Sandals3DDiagram />} />
          <Route path="/sandals-fusion-test" element={<SandalsFusionTest />} />
          <Route path="/sandals-stl-carousel" element={<SandalsStlCarousel />} />
          <Route path="/sandals-baked-library" element={<SandalsBakedLibrary />} />
          <Route path="/sandals-live-explorer" element={<SandalsLiveExplorer />} />
          <Route path="/sandals-morph-lab" element={<SandalsMorphLab />} />
          <Route path="/sandals-morph-lab-mobile" element={<SandalsMorphLabMobile />} />
          <Route path="/engagement" element={<Engagement />} />
          <Route path="/start" element={<Start />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}

export default App
